module.exports = __webpack_public_path__ + "media/images/ecalls/footer_bitcoin_bottom-60159cd07e8cd6ef54773e9f83a2b838.png";